import { decryptData } from '../utils/encryptionUtils';
import { globalConfig } from '../globalConfig';
import { axios } from '../lib';


const GUEST_TOKEN_ENDPOINT = '/user/guest-auth-token/';
const CONFIG_ENDPOINT = '/user/config/';
const X_TOKEN_VALUE = process.env.X_SECURE_TOKEN;
const DECRYPTION_SECRET = 'onMkwpmZqfYZ5hrXkiEx';

export interface AzureConfig {
    client_id: string;
    tenant_id: string;
    // Add other fields if your config has them
}

export const fetchAndDecryptConfig = async (): Promise<AzureConfig> => {
    try {
        // 1. Get Guest Token
        // Using axios.post with headers in the config object
        const tokenResponse = await axios.post<any>(
            GUEST_TOKEN_ENDPOINT,
            {}, // Empty body for POST if not required, or remove if GET is expected
            {
                headers: {
                    'X-SECURE-TOKEN': X_TOKEN_VALUE
                }
            }
        );

        // Axios automatically parses JSON, so we can access .data directly
        const guestToken = tokenResponse.data.token;

        if (!guestToken) {
            throw new Error('Guest token not found in response');
        }

        // 2. Get Encrypted Config
        // Using axios.get with Authorization header
        const configResponse = await axios.get<any>(
            CONFIG_ENDPOINT,
            {
                headers: {
                    'Authorization': `Bearer ${guestToken}`
                }
            }
        );

        const encryptedConfig = configResponse.data;
        // 3. Decrypt Config
        const decryptedConfig = await decryptData(encryptedConfig, DECRYPTION_SECRET);
        // Build a simple key -> secret map from the secrets array
        const secretsArray: { key: string; secret: string }[] = decryptedConfig.secrets ?? [];
        const secretMap: Record<string, string> = secretsArray.reduce(
            (acc, item) => {
                acc[item.key] = item.secret;
                return acc;
            },
            {} as Record<string, string>
        );

        // Extract the specific values you care about
        const clientId = secretMap['microsoft-client-id'];
        const tenantId = secretMap['microsoft-tenant-id'];
        const ConnectionString = secretMap['azure-app-insights-connection-string'];
        const clientSecret = secretMap['dna-dbs-sp-appsecret'];
        const appClientId = secretMap['dna-dbs-sp-appid'];

        if (!clientId || !tenantId) {
            throw new Error('Missing microsoft-client-id or microsoft-tenant-id in decrypted secrets');
        }

        // SAVE TO GLOBAL CONFIG
        globalConfig.setConfig({
            client_id: clientId,
            tenant_id: tenantId,
            appInsightsConnectionString: ConnectionString,
            client_secret_key: clientSecret,
            app_client_id: appClientId
        });

        // SAVE TO GLOBAL CONFIG
        // globalConfig.setConfig({
        //     client_id: decryptedConfig['microsoft-client-id'],
        //     tenant_id: decryptedConfig['microsoft-tenant-id'],
        //     appInsightsConnectionString: decryptedConfig['azure-app-insights-connection-string'], // Adjust key name based on your API response
        // });

        
        return decryptedConfig as AzureConfig;

    } catch (error) {
        console.error('Error fetching auth config:', error);
        throw error;
    }
};